import React from 'react';
import { LayersIcon } from 'lucide-react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-slate-200 bg-slate-50 py-14 md:py-16" data-id="element-52" data-mp="3gg1025qei1yp">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-53" data-mp="32ovukn0cqfgg">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-wider text-blue-600 md:text-lg md:tracking-widest" data-id="element-54" data-mp="36oxzr65apr0h">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-55" data-mp="3uftmvpyt3y1e" />
          50 Fiches Visuelles de Placement des Électrodes en Kinésithérapie
        </p>

        <p className="mx-auto mt-5 max-w-xl text-slate-600" data-id="element-56" data-mp="3lf598wdbrzp1">
          Matériel numérique | Accès immédiat | Garantie 7 jours satisfait ou remboursé
        </p>

        <nav aria-label="Liens légaux" data-id="element-57" data-mp="3qf9suv9j5ajh">
          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-slate-600" data-id="element-58" data-mp="29yxbr9cr3ek8">
            {footerLinks.map(link => <li key={link.label} data-id="element-59" data-mp="2ew734ujpa0ap">
                <a href={link.href} className="rounded transition-colors duration-150 ease-out hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-60" data-mp="3l90n1twdyuy7">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-10 border-t border-slate-200 pt-6 text-sm text-slate-500" data-id="element-61" data-mp="3qaq17iewnoqi">
          © 2026 50 Fiches Visuelles de Placement des Électrodes en Kinésithérapie. Tous droits réservés.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-slate-500" data-id="element-62" data-mp="31up7hdvubpd">
          Matériel éducatif et de consultation visuelle destiné aux étudiants et aux professionnels. Il
          ne remplace pas l’évaluation clinique individuelle, la formation professionnelle, les
          instructions du fabricant ni les protocoles de l’établissement.
        </p>
      </div>
    </footer>;
}